import React, { ReactElement, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import useFetch from 'use-http';

import api from 'config';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import { columns } from './viewMeta';
import { Container } from './styles';
import { defaultAction } from './actions'

interface MyProfileProps {
    
}

 function MyProfile({}: MyProfileProps): ReactElement {
    const [todos, setTodos] = useState(undefined)
    const { get, post, response, loading, error } = useFetch(`${api.config.companyAPI}`)
  
    useEffect(() => {
        initialData()
    }, [])

    async function initialData() {
        const response = await get('/captainpayment/auth/v1/me')
        if (response.ok) {
            var data = await response.json()
            setTodos(data)
        }
    }

    return (
        <Container>

        </Container>
    )
}

const mapStateToProps = (state) => {
    // return { todos: state.todos };
    return {

    };
}

const mapDispatchToProps = (dispatch, ownProps) => {
    // const boundActions = bindActionCreators({ defaultAction }, dispatch)
  return {
    // dispatchPlainObject: () => dispatch({ type: 'MY_ACTION' }),
    // dispatchActionCreatedByActionCreator: () => dispatch(createMyAction()),
    // ...boundActions,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile)